<div class="form-review-dashboard">
  <div class="header-row">
    <div class="header-info-content">
      <span style="font-weight: bold;">Form Review</span>
      <span style="margin-left: 15px;">
        @for (cat of ['C', 'P']; track $index) {
<span
              class="filter-btn" [class.active]="filter.category === cat"
              (click)="catChanged(cat)">
          {{filterCatMapping[cat]}}
        </span>
}
        |
        @for (loc of ['D', 'F']; track $index) {
<span
              class="filter-btn" [class.active]="filter.location === loc"
              (click)="locChanged(loc)">
          {{filterLocMapping[loc]}}
        </span>
}
        |
        @for (le of ['HO', 'HOO', 'TXN', 'BRANCH', 'BSLA', 'CONSOL', 'PSHIP']; track $index) {
<span
              class="filter-btn" [class.active]="filter.lEType === le"
              (click)="leTypeChanged(le)">
          {{le}}
        </span>
}
      </span>
    </div>
  </div>

  <div class="dashboard-body">
    <div class="entity-list-panel">
      <div class="panel-header">
        <input type="text" [ngModel]="searchTerm" (ngModelChange)="searchTerm=$event" placeholder="Search entities..." class="search-input">
        <span class="record-count">{{recordsCount}} entities</span>
      </div>
      @if (loadingList) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 24px;"></i>
      </div>
}
      @if (!loadingList) {
<div class="entity-items">
        @for (entity of flatData; track $index) {
<div class="entity-item"
             [class.selected]="selectedEntity === entity"
             (click)="selectEntity(entity)">
          <span>{{entity.LE_NAME || entity.LEID || entity.name}}</span>
        </div>
}
      </div>
}
    </div>

    @if (selectedEntity) {
<div class="forms-panel">
      <div class="panel-header">
        <span style="font-weight: bold;">Forms for {{selectedEntity.LE_NAME || selectedEntity.LEID}}</span>
      </div>
      @if (loadingForms) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 24px;"></i>
      </div>
}
      @if (!loadingForms) {
<div class="form-items">
        @for (form of formsPerEntity; track $index) {
<div class="form-item">
          <span>{{form.FORM_NAME || form.form_name || form.name}}</span>
        </div>
}
      </div>
}
    </div>
}
  </div>
</div>
